const parseLocalStorageItem = <ReturnType>(key: any): ReturnType | null => {
  if (key === "undefined") {
    return null;
  } else {
    return key;
  }
};

const getStorageToken = () =>
  parseLocalStorageItem<string>(localStorage.getItem("authStorage"));

export { getStorageToken };
